import PropTypes from 'prop-types'
import {
  DropdownHintContainer,
  DropdownHintText
} from '../styled-components'

const AutoCompleteHint = ({ hint }) => {
  if (!hint) return null

  return (
    <DropdownHintContainer>
      <DropdownHintText>{hint}</DropdownHintText>
    </DropdownHintContainer>
  )
}

AutoCompleteHint.propTypes = {
  hint: PropTypes.string
}

export default AutoCompleteHint
